import React, { useEffect, useState } from 'react';
// Constants
import { CompanyName, KeywordsPages } from '../../utils/Constants';
// Data
import {
  linksPageAdditionalMeta,
  linksPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GeneralHeader from '../../components/header/GeneralHeader';
import LinksPageMainContainer from '../../components/links/LinksPageMainContainer';

function LinksPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-links');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='External Links & Pay Sites'
        desc={`Explore the exclusive world of ${CompanyName}. Access my premium content, tribute options, and private platforms. Indulge in the experience that awaits.`}
        keywords={KeywordsPages}
        additionalMeta={linksPageAdditionalMeta}
        structuredData={linksPageStructuredData}
      />

      {/* Page */}
      <div className='grid min-h-screen font-main bg-colour1 dark:bg-colour2 text-colour2 dark:text-colour1 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-links'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />
          {/* Header */}
          <GeneralHeader
            page={`Extra Links`}
            title={`Find Me For More Erotic Content`}
            subtitle={`Spoil me and treat me like a Goddess!`}
          />
        </div>

        {/* Main page content */}
       <LinksPageMainContainer />
      </div>
    </>
  );
}

export default LinksPage;
